<template>
  <form @submit.prevent="saveSocialNumber(formScope)" :data-vv-scope="formScope" class="ui large form">
    <div class="field required" :class="{ 'error' : errors.has(formScope + '.social_number')}">
      <label for="social_number">{{ $t('pages.profile.settings.profile.form.social_number') }}</label>
      <div class="ui input corner labeled">
        <input type="text" v-model="form.social_number" name="social_number" :data-vv-as="$t('pages.profile.settings.profile.form.social_number')" v-validate="'required|numeric'">

        <div class="ui corner label">
          <i class="asterisk icon"/>
        </div>
      </div>
      <span style="color:red;" v-if="errors.has(formScope + '.social_number')">{{ errors.first(formScope + '.social_number') }}</span>
    </div>
  </form>
</template>

<script>
export default {
  name: 'SocialNumberSetup',

  data () {
    return {
      formScope: 'social-number-setup',

      form: {
        social_number: this.$auth.user().social_number ? this.$auth.user().social_number : ''
      }
    }
  },

  methods: {
    saveSocialNumber (formScope) {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll(formScope)
          .then(result => {
            if (result) {
              this.axios.put('users/social_number', {
                social_number: this.form.social_number
              })
                .then(() => {
                  this.$auth.fetch()

                  this.$events.$emit('alert', {
                    header: this.$t('globals.validation.success.success'),
                    message: this.$t('pages.setup.validation.success.user_success'),
                    type: 'success',
                    closebutton: true,
                    align: 'right'
                  })

                  resolve(true)
                }).catch(() => {
                reject()
              })
            }
          }).catch()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/setup/SocialNumberSetup.vue